module.exports = __webpack_public_path__ + "static/media/profile-picture__no_picture.3ff9dc91.svg";